var exports = {
  "B": "DataMarquee__z4aEos",
};

module.exports = exports;
